<script setup>
// Figurinha (sticker) do WhatsApp — chega como anexo image/webp (filename
// sticker.webp) pelo ByCall. Renderiza pequeno e sem balão (fundo
// transparente), como o WhatsApp nativo — não como uma imagem grande.
// Detecção/roteamento no Message.vue (anexo único image + extensão webp).
import { ref, computed, onMounted } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import { useLoadWithRetry } from 'dashboard/composables/loadWithRetry';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

const { attachments, filteredCurrentChatAttachments } = useMessageContext();

const attachment = computed(() => attachments.value[0]);
const showGallery = ref(false);
const { isLoaded, hasError, loadWithRetry } = useLoadWithRetry();

onMounted(() => {
  if (attachment.value?.dataUrl) {
    loadWithRetry(attachment.value.dataUrl);
  }
});

const handleImageError = () => {
  hasError.value = true;
};
</script>

<template>
  <BaseBubble
    class="!bg-transparent !p-0 !shadow-none"
    data-bubble-name="sticker"
    hide-meta
  >
    <img
      v-if="isLoaded && !hasError"
      :src="attachment.dataUrl"
      class="object-contain cursor-pointer size-[130px] skip-context-menu"
      @click="showGallery = true"
      @error="handleImageError"
    />
    <div
      v-else-if="hasError"
      class="flex items-center justify-center rounded-lg size-[130px] bg-n-alpha-1 text-n-slate-10"
    >
      <span class="i-ph-sticker size-8" />
    </div>
  </BaseBubble>

  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleImageError"
    @close="() => (showGallery = false)"
  />
</template>
